import { Link } from "react-router-dom";
import logo from "../../assets/logo.png"; // Update path to your logo

export default function Footer() {
  return (
    <footer
      className="bg-[#0e1a10] text-white py-10 px-4 text-sm border-t border-white/10 font-manrope relative z-10"
      data-aos="fade-up"
      data-aos-delay="100"
      data-aos-duration="800"
    >
      <div className="max-w-6xl mx-auto flex flex-col md:flex-row justify-between items-center gap-6">
        
        <div className="flex items-center gap-3">
          <Link to="/" className="flex items-center gap-2">
            <img src={logo} alt="FitTrack Logo" className="w-8 h-8 rounded-full" />
            <span className="text-green-400 text-lg font-semibold hover:underline">
              FitTrack
            </span>
          </Link>
        </div>

        
        <div className="flex gap-6 text-gray-400">
          <Link to="/privacy" className="hover:text-green-400 transition duration-300">
            Privacy Policy
          </Link>
          <Link to="/terms" className="hover:text-green-400 transition duration-300">
            Terms of Service
          </Link>
          <Link to="/contact" className="hover:text-green-400 transition duration-300">
            Contact Us
          </Link>
        </div>

        
        <p className="text-gray-500 text-center md:text-right">
          © {new Date().getFullYear()} <span className="text-green-400">FitTrack</span>. All rights reserved Aditya chauhan.
        </p>
      </div>
    </footer>
  );
}
